export enum Buttons {
  IMPORT_CROSSES = 'Import Crosses',
  IMPORT_PRODUCT_EDITS = 'Import Product Edits',
  CUSTOM_REQUEST = 'Custom Request',
  CREATE_REQUEST = 'Create Request',
  DOWNLOAD = 'Download',
  IMPORT = 'Import',
  SEND = 'Send',
}
